
// utils/ephemerides-provider.js
// Provider con cache: carica/parsa una volta e riusa.
// Dipende da parseEphemeridesCSV (che esporti dal tuo modulo).

import { parseEphemeridesCSV } from './planet-ingresses.js';

const CSV_URL = '/assets/effemeridi.csv'; // <-- aggiorna path

let rowsPromise = null;     // cache della Promise (evita doppio fetch)
let rowsCache   = null;     // cache del risultato (array rows)

export async function getEphemeridesRows(csvUrl = CSV_URL) {
  // se già abbiamo il risultato, restituisci subito
  if (Array.isArray(rowsCache)) return rowsCache;

  // se è già in corso un fetch/parsing, riusa la stessa Promise
  if (rowsPromise) return rowsPromise;

  rowsPromise = (async () => {
    const csvText = await fetch(csvUrl).then(r => r.text());
    const rows = parseEphemeridesCSV(csvText);
    rowsCache = rows;
    return rows;
  })();

  return rowsPromise;
}

// opzionale: invalidazione manuale (se mai servirà ricaricare un CSV diverso)
export function resetEphemeridesCache() {
  rowsPromise = null;
  rowsCache = null;
}
